var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconDelete = function SvgIconDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.618,
    height: 13.346,
    viewBox: "0 0 11.618 13.346",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_933",
    "data-name": "Group 933",
    transform: "translate(6034.746 -4016.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_932",
    "data-name": "Group 932",
    transform: "translate(-6034.445 4016.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_931",
    "data-name": "Group 931",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_930",
    "data-name": "Group 930",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_924",
    "data-name": "Group 924",
    transform: "translate(0.648 2.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2453",
    "data-name": "Path 2453",
    d: "M980.919,870.125l-.4,9.508a.8.8,0,0,1-.792.758h-6.913a.8.8,0,0,1-.792-.758l-.4-9.508a.108.108,0,0,0-.216.009l.4,9.508a1.017,1.017,0,0,0,1.008.965h6.913a1.016,1.016,0,0,0,1.008-.965l.4-9.508a.108.108,0,0,0-.216-.009Z",
    transform: "translate(-971.414 -870.022)",
    fill: "#173a6d",
    stroke: "#173a6d",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_925",
    "data-name": "Group 925",
    transform: "translate(5.401 3.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2454",
    "data-name": "Path 2454",
    d: "M987.724,874.577v7.345a.108.108,0,1,0,.216,0v-7.345a.108.108,0,0,0-.216,0Z",
    transform: "translate(-987.724 -874.469)",
    fill: "#173a6d",
    stroke: "#173a6d",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_926",
    "data-name": "Group 926",
    transform: "translate(3.024 3.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    d: "M979.569,874.581l.216,7.345a.108.108,0,1,0,.216-.006l-.216-7.345a.108.108,0,0,0-.216.006Z",
    transform: "translate(-979.569 -874.47)",
    fill: "#173a6d",
    stroke: "#173a6d",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_927",
    "data-name": "Group 927",
    transform: "translate(7.561 3.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    d: "M995.354,874.574l-.216,7.345a.108.108,0,1,0,.216.006l.216-7.345a.108.108,0,0,0-.216-.006Z",
    transform: "translate(-995.138 -874.47)",
    fill: "#173a6d",
    stroke: "#173a6d",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_928",
    "data-name": "Group 928",
    transform: "translate(0 1.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    d: "M969.3,866.53h10.8a.108.108,0,0,0,0-.216H969.3a.108.108,0,0,0,0,.216Z",
    transform: "translate(-969.19 -866.314)",
    fill: "#173a6d",
    stroke: "#173a6d",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_929",
    "data-name": "Group 929",
    transform: "translate(3.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    d: "M980.537,863.836l.231-.578a.755.755,0,0,1,.641-.434h2.376a.752.752,0,0,1,.641.434l.231.578.2-.08-.231-.578a.967.967,0,0,0-.841-.57h-2.376a.97.97,0,0,0-.841.57l-.231.578Z",
    transform: "translate(-980.337 -862.607)",
    fill: "#173a6d",
    stroke: "#173a6d",
    strokeWidth: 0.6
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_delete.e772463b.svg";
export { ForwardRef as ReactComponent };